export const KOR_BANK_LIST = [
  { code: '000', name: '없음' },
  { code: '088', name: '신한' },
  { code: '035', name: '제주' },
  { code: '004', name: '국민' },
  { code: '003', name: '기업' },
  { code: '011', name: '농협' },
  { code: '002', name: '산업' },
  { code: '007', name: '수협' },
  { code: '048', name: '신협' },
  { code: '020', name: '우리' },
  { code: '081', name: '하나' },
  { code: '027', name: '한국씨티' },
  { code: '090', name: '카카오뱅크' },
  { code: '089', name: '케이뱅크' },
  { code: '092', name: '토스뱅크' },
  { code: '039', name: '경남' },
  { code: '034', name: '광주' },
  { code: '031', name: '아이엠뱅크(대구)' },
  { code: '032', name: '부산' },
  { code: '037', name: '전북' },
  { code: '045', name: '새마을' },
  { code: '071', name: '우체국' },
  { code: '050', name: '저축은행' },
  { code: '012', name: '지역농.축협' },
  { code: '055', name: '도이치' },
  { code: '063', name: '중국' },
  { code: '067', name: '중국건설' },
  { code: '062', name: '중국공상' },
  { code: '061', name: 'BNP파리바' },
  { code: '060', name: 'BOA' },
  { code: '054', name: 'HSBC' },
  { code: '057', name: 'JP모간' },
  { code: '023', name: 'SC' },
  { code: '064', name: '산림조합' },
  { code: '278', name: '신한투자증권' },
  { code: '261', name: '교보증권' },
  { code: '227', name: '다올투자증권' },
  { code: '267', name: '대신증권' },
  { code: '287', name: '메리츠증권' },
  { code: '238', name: '미래에셋증권' },
  { code: '290', name: '부국증권' },
  { code: '240', name: '삼성증권' },
  { code: '221', name: '상상인증권' },
  { code: '291', name: '신영증권' },
  { code: '266', name: '에스케이증권' },
  { code: '209', name: '유안타증권' },
  { code: '280', name: '유진투자증권' },
  { code: '265', name: 'LS증권' },
  { code: '288', name: '카카오페이증권' },
  { code: '292', name: '케이프투자증권' },
  { code: '264', name: '키움증권' },
  { code: '271', name: '토스증권' },
  { code: '294', name: '우리투자증권' },
  { code: '270', name: '하나증권' },
  { code: '262', name: '아이엠증권' },
  { code: '243', name: '한국투자증권' },
  { code: '269', name: '한화투자증권' },
  { code: '263', name: '현대차증권' },
  { code: '224', name: 'BNK투자증권' },
  { code: '279', name: 'DB금융투자' },
  { code: '225', name: 'IBK투자증권' },
  { code: '218', name: 'KB증권' },
  { code: '247', name: 'NH투자증권' },
];
